const createToast = options => {
  return {
    ...options,
    id: Math.random().toString(36)
  }
}

export { createToast }
